<template>
 <div id="ContainerPatientAsam">
  <Asam v-bind:PatientCode="this.$route.params.id" v-bind:RecordId="this.$route.params.recordid"/>
</div>

</template>
<script>
import Asam from "@/components/asam/Asam";
import DBFunctions from '@/common/DBFunctions.js'
import EnumService from '@/services/enum.service'
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission'

export default {

  /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iUA = await vm.$store.state.isUseASAM;
            if(iUA) next()
            else next('/accessdenied');
        }) 
  },*/
  
  components: { Asam },
  mixins: [DBFunctions,Permission],
  data() {
    return {
      //permission:[],
      //Menu : this.$store.state.leftMenu,
      OptionsRightMenu:{
			visible:true,
			ItemsList:[],
			btnvisible:true,
			itemdisabled: false,		
		}
    }
  },
 
methods:{
MenuVisible(){
    this.OptionsRightMenu.visible = true; 
    this.OptionsRightMenu.btnvisible = true;      
    this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems;
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
    this.$emit('getBtnRightMenu', this.OptionsRightMenu); 
}
},

  mounted() {
    EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
     }.bind(this));
    this.MenuVisible();
  },
  
  updated(){
  this.MenuVisible();
  },
  destroyed(){

  }
}

</script>





